module.exports = __webpack_public_path__ + "static/media/search staff by post.3d9f1c8c.svg";